/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: block;
  cursor: pointer;
  padding: 0 1.1428571429rem 0 0.7142857143rem;
  line-height: 2.5714285714rem;
  min-height: 2.5714285714rem;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  border-left: 0.4285714286rem solid rgba(255, 255, 255, 0);
}

:host([highlighted]),
:host([selected]) {
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
  color: #2C3133;
  color: var(--davinci-color-text-on-background-3, #2C3133);
}

:host([selected]) {
  border-color: var(--davinci-color-primary-light,#009DF4);
}

:host([disabled]) ::slotted(*),
:host([disabled]) {
  pointer-events: none;
  cursor: default;
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}

:host,
* {
  box-sizing: border-box;
}

:host([hidden]) {
  display: none;
}`;
export { style };
